import React from "react";
import { Field } from "redux-form";
import { Segment, Header } from "semantic-ui-react";

function Pago(props) {
  return (
    <Segment>
      <Header as="h3">Consentimiento</Header>
      <p>
        <label style={{ cursor: "pointer" }}>
          <Field
            id="consentimiento"
            name="consentimiento"
            type="checkbox"
            component="input"
          />{" "}
          Al marcar esta casilla, doy mi consentimiento expreso a que Aristas
          Educación se ponga en contacto conmigo para informarme de cualquier
          asunto referente única y exclusivamente a la Escuela de Verano.
        </label>
      </p>
      <p>
        Los datos aquí proporcionados se emplean única y exclusivamente para
        gestionar la inscripción de los alumnos a las escuelas de verano
        organizadas por Aristas Educación. Asímismo, los datos de contacto
        proporcionados se emplearán para resolver cualquier problema o
        incidencia que surja relacionada con la escuela de verano.
      </p>
      <p>
        En ningún caso los datos proporcionados serán cedidos en forma alguna a
        terceros, ni serán empleados para enviar publicidad, ni actividad
        comercial alguna ni ningún tipo de información no relacionada con la
        realización de la Escuela de Verano 2018 de Aristas.
      </p>
    </Segment>
  );
}

export default Pago;



// WEBPACK FOOTER //
// ./src/pages/inscripciones/hojaInscripcion/formularioInscripcion/Legal.jsx